import axios from '../../axios-default';
import { uiStartLoading, uiStopLoading } from '../loading/actions';
import {
    FINISHING_RETAINER_SELECT_OPTION,
    FINISHING_RETAINER_CHANGE_TAB,
    FINISHING_RETAINER_IMPRESSION_SELECT_OPTION,
} from './actionType';

export const requestFinishingRetainerChangeTab = (payload) => ({
    type: FINISHING_RETAINER_CHANGE_TAB,
    payload,
});
export const requestFinishingRetainerSelectOptsB = (payload) => ({
    type: FINISHING_RETAINER_IMPRESSION_SELECT_OPTION,
    payload,
});

export const requestFinishingRetainerSelectOpts = (payload) => ({
    type: FINISHING_RETAINER_SELECT_OPTION,
    payload,
});
